import { MQReference } from "@eres/mortgageQuotationAPI/entities";
import React, { Component } from "react";
import Popup from "../Popup/Popup";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";
import { JQModal } from "../Popup/Utils";

interface Props {
	references: MQReference[];
	onDismiss: () => void;
}

class MQRequestSuccess extends Component<Props> {
	render() {
		const { references, onDismiss } = this.props;
		return <Popup
			id={ "AddBanks" }
			autoOpenMount={ true }
			title={ Strings.mortgage_quotation }
			showIcon={ false }
			onDismiss={ () => {
				JQModal( "AddBanks" ).hide();
				onDismiss();
			} }>
			<div className="send-message-success success-modal-quotation">
				<div className="check-icon">
					<i className="fa fa-check"/>
				</div>
				<p className="text-center">{ Strings.mortgage_submit }</p>
				<div className="flex-grid mt-4 mb-3">
					<div>
						<span><b>{ Strings.bank_name }</b></span>
						<span><b>{ Strings.reference_number }</b></span>
					</div>
					{ references.map( ( reference: MQReference ) => {
						return <div key={ `mq_req_ref_${ reference.id }` }>
							<span>{ LocaleUtil.getLocalValue( reference.bank ) }</span>
							<span>{ reference.id }</span>
						</div>;
					} ) }
				</div>
				<div className="modal-footer d-flex justify-content-center">
					<button
						type="button" className="btn btn_1 btn_style1"
						onClick={ () => {
							JQModal( "AddBanks" ).hide();
							onDismiss();
						} }>{ Strings.back }</button>
				</div>
			</div>
		</Popup>;
	}
}

export default MQRequestSuccess;
